export default {
    InternalRefundOrderDetailsOnly: {
        Refund: '退款单详情',
        Refresh: '刷 新',
        Approved: '审核通过',
        Approval: '审核拒绝',
        Rejected: '已拒绝',
        Reason: '原因：',
        Reviewed: '审核人',
        Approvaltime: '审核时间',
        Canceled: '已取消',
        Exception: '转单异常',
        Basic: '基础信息',
        Basicc: '待审核才能修改',
        Modify: '修改',
        Refundnote: '退款单类型',
        Store: '店 铺',
        Refundtype: '退款类型',
        Refundreason: '退款原因',
        Refundstage: '退款阶段',
        Refundremarks: '退款备注',
        Customer: '客服备注',
        information: '买家信息',
        nickname: '买家昵称',
        Refundby: '退款人',
        Mobile: '退款人手机号',
        address: '退款人地址',
        Financial: '财务信息',
        Settlement: '结算方式',
        labels: '添加标签',
        Associated: '关联单据',
        Associateds: '内部退款单号',
        Thirdparty: '三方退款单号',
        Thirdorder: '客户订单号',
        Internal: '内部订单号',
        creation: '内部创单时间',
        Threerefund: '三方退款时间',
        Refundtime: '退款完成时间',
        Image: '图片附件',
        Upload: '上传',
        Product: '商品信息',
        Add: '添加退款商品',
        Select: '选择退款的商品',
        Other: '其它',
        Unshipped: '未发货数量：',
        Refunded: '已退款数量：',
        Refundable: '可退款数量：',
        Shipment: '发货状态：',
        Preemption: '预占状态：',
        Sourcing: '寻源状态：',
        Delete: '删除',
        Is: '是否赠品',
        Item: '商品行数量',
        quantity: '退款数量',
        unit: '退款单价',
        Total: '退款合计',
        Operation: '操作',
        Approveed: '审核通过',
        Audit: '审核拒绝',
        Cancel: '取消',
        Otherr: '其他',
        Are: '您确认要通过审核吗？',
        Auditrejected: '审核拒绝',
        Pleasereason: '请输入拒绝原因',
        Pleaseenter: '请输入',
        Areyou: '您确认要取消该退款单吗？',
        Cancelyou: '取消原因',
        Cancellation: '取消成功',
        Modifybasic: '修改基础信息',
        Modifycustomer: '修改客服备注',
        wantot: '是否删除此附件？',
        wantto: '是否删除此标签？',
        The: '可退款数量为0',
        Theis: '返回数据为空，请联系管理员',
        BankTitle: '银行信息',
        BankMethod: '退款方式',
        BankID: '交易ID',
        BankComments: '卖方意见',
        BankName: '银行名称',
        BankAccount: '银行账号',
        BankBSB: '银行BSB编号',
        LogisticsRules: '物流规则'
    }
};
